import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = ["checked"]
const _hoisted_11 = ["checked"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = { class: "col-3" }
const _hoisted_14 = ["label", "value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["label", "value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["label", "value"]
const _hoisted_19 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("dig-input-text", {
      value: _ctx.demand.name,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update('name', $event.target.value)))
    }, _toDisplayString(_ctx.$t('Demand.name')), 41, _hoisted_1),
    _createElementVNode("dig-input-textarea", {
      value: _ctx.demand.description,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.update('description', $event.target.value)))
    }, _toDisplayString(_ctx.$t('Demand.description')), 41, _hoisted_2),
    (_ctx.isAdmin)
      ? (_openBlock(), _createElementBlock("dig-input-number", {
          key: 0,
          "disabled-negative": "true",
          "decimal-count": "1",
          value: _ctx.demand.points,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update('points', $event.target.value)))
        }, _toDisplayString(_ctx.$t('Demand.points')), 41, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("dig-input-text", {
        value: _ctx.demand.version,
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.update('version', $event.target.value)))
      }, _toDisplayString(_ctx.$t('Demand.version')), 41, _hoisted_5),
      _createElementVNode("dig-input-text", {
        value: _ctx.demand.browser,
        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.update('browser', $event.target.value)))
      }, _toDisplayString(_ctx.$t('Demand.browser')), 41, _hoisted_6),
      _createElementVNode("dig-input-text", {
        value: _ctx.demand.os,
        onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.update('os', $event.target.value)))
      }, _toDisplayString(_ctx.$t('Demand.os')), 41, _hoisted_7)
    ]),
    (!_ctx.createForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("dig-input-checkbox", {
            checked: _ctx.demand.customerChecked,
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.update('customerChecked', $event.detail)))
          }, _toDisplayString(_ctx.$t('Demand.checkedBy', { name: _ctx.project.name })), 41, _hoisted_10),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("dig-input-checkbox", {
                key: 0,
                checked: _ctx.demand.providerChecked,
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.update('providerChecked', $event.detail)))
              }, _toDisplayString(_ctx.$t('Demand.checkedBy', { name: 'Digithia' })), 41, _hoisted_11))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("dig-input-radio-wrapper", {
        label: _ctx.$t('Demand.priority'),
        value: _ctx.demand.priority,
        onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.update('priority', $event.detail)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priorities, (priority) => {
          return (_openBlock(), _createElementBlock("dig-input-radio", {
            key: priority,
            value: priority
          }, _toDisplayString(_ctx.$t('Demand.Priority.' + priority)), 9, _hoisted_15))
        }), 128))
      ], 40, _hoisted_14),
      (_ctx.isAdmin && !_ctx.createForm)
        ? (_openBlock(), _createElementBlock("dig-input-radio-wrapper", {
            key: 0,
            label: _ctx.$t('Demand.state'),
            value: _ctx.demand.state,
            onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.update('state', $event.detail)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state) => {
              return (_openBlock(), _createElementBlock("dig-input-radio", {
                key: state,
                value: state
              }, _toDisplayString(_ctx.$t('Demand.State.' + state)), 9, _hoisted_17))
            }), 128))
          ], 40, _hoisted_16))
        : _createCommentVNode("", true),
      _createElementVNode("dig-input-radio-wrapper", {
        label: _ctx.$t('Demand.nature'),
        value: _ctx.demand.nature,
        onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.update('nature', $event.detail)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.natures, (nature) => {
          return (_openBlock(), _createElementBlock("dig-input-radio", {
            key: nature,
            value: nature
          }, _toDisplayString(_ctx.$t('Demand.Nature.' + nature)), 9, _hoisted_19))
        }), 128))
      ], 40, _hoisted_18)
    ])
  ]))
}